function init() {
    if (window.$$epiforms) {
        window.$$epiforms(".EPiServerForms").on("formsSubmitted", (event) => {
            const { currentTarget: form } = event;

            if (
                form &&
                form.parentElement &&
                form.parentElement.parentElement
            ) {
                form.parentElement.parentElement.scrollIntoView({
                    behavior: "smooth",
                });
            }
        });
    }
}

export default { init };
